export class MeshInstructions {
  position: number[];
  length: number[];

  constructor(lineLength?: number) {
    if (lineLength) {
      this.position = [0, lineLength];
      this.length = [1, 1];
    } else {
      this.position = [];
      this.length = [];
    }
  }
}
